"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _redux = require("redux");
var _memberFaqActionKeys = _interopRequireDefault(require("../constants/memberFaqActionKeys"));
var _angieslistAppPlatform = require("angieslist-app-platform");
var faqTopics = [{
  topicId: '1',
  topicName: 'Account Settings'
}, {
  topicId: '2',
  topicName: 'General'
}, {
  topicId: '3',
  topicName: 'Reviews'
}, {
  topicId: '4',
  topicName: 'Memberships'
}, {
  topicId: '5',
  topicName: 'Tools & Features'
}, {
  topicId: '7',
  topicName: 'Member Benefits'
}, {
  topicId: '8',
  topicName: 'Common FAQ\'s'
}];
var faqTopicReducer = function faqTopicReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : faqTopics;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return state;
};
var _default = exports["default"] = (0, _redux.combineReducers)({
  memberFaqs: _angieslistAppPlatform.AsyncRequest.createReducer(_memberFaqActionKeys["default"].GET_MEMBER_FAQ),
  faqTopics: faqTopicReducer
});
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/reducers/memberFaqReducer.js
// module id = 4395
// module chunks = 9